var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEraseVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 22.5",
    style: {
      enableBackground: "new 0 0 30 22.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#444444;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.5,0H8.8c-0.9,0-1.5,0.4-2,1.1L0,11.3l6.8,10.1c0.5,0.7,1.1,1.1,2,1.1h18.8c1.4,0,2.5-1.1,2.5-2.5V2.5 C30,1.1,28.9,0,27.5,0z M27.5,20H8.8L3,11.3l5.8-8.8h18.7V20z M13,17.5l4.5-4.5l4.5,4.5l1.8-1.8l-4.5-4.5l4.5-4.5L22,5l-4.5,4.5 L13,5l-1.8,1.8l4.5,4.5l-4.5,4.5L13,17.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraseVerify);
export default __webpack_public_path__ + "static/media/erase-verify.5b8052232705ff01f1c2d3664151c7da.svg";
export { ForwardRef as ReactComponent };